module.exports = __webpack_public_path__ + "img/ynCode.a71c6ef9.png";